import { ADDRESS_ACTION_TYPES, ADDRESS_FIELD_NAMES } from './actionTypes';

const initialState = {
    fields: {
        [ADDRESS_FIELD_NAMES.FIRSTNAME]: '',
        [ADDRESS_FIELD_NAMES.LASTNAME]: '',
        [ADDRESS_FIELD_NAMES.PHONE_COUNTRY]: 'RU',
        [ADDRESS_FIELD_NAMES.PHONE]: '',
        [ADDRESS_FIELD_NAMES.EMAIL]: '',
        [ADDRESS_FIELD_NAMES.IS_JURIDIC]: false,

        [ADDRESS_FIELD_NAMES.COMPANY]: '',
        [ADDRESS_FIELD_NAMES.COMPANY_INN]: '',
        [ADDRESS_FIELD_NAMES.COMPANY_KPP]: '',
        [ADDRESS_FIELD_NAMES.COMPANY_OGRN]: '',
        [ADDRESS_FIELD_NAMES.COMPANY_CHIEF_NAME]: '',
        [ADDRESS_FIELD_NAMES.COMPANY_CONTACT_NAME]: '',
        [ADDRESS_FIELD_NAMES.COMPANY_JOB_TITLE]: '',
        [ADDRESS_FIELD_NAMES.COMPANY_SCOPE]: '',
        [ADDRESS_FIELD_NAMES.COMPANY_LEGAL_ADDR]: '',
        [ADDRESS_FIELD_NAMES.COMPANY_POST_ADDR]: '',

        hasErrors: false,
    },
    countriesList: [],
    isFetching: false,
};

export const addressReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADDRESS_ACTION_TYPES.SET_ADDRESS_FIELDS:
            return {
                ...state,
                fields: {
                    ...state.fields,
                    ...action.data,
                },
            };

        case ADDRESS_ACTION_TYPES.REQUEST_COUNTRIES:
            return {
                ...state,
                isFetching: true,
            };

        case ADDRESS_ACTION_TYPES.RECEIVE_COUNTRIES:
            return {
                ...state,
                countriesList: action.data,
                isFetching: false,
            };

        default:
            return state;

    }
};